<section>
  <header>
    <h1>{{ title }}</h1>
  </header>
  <div class="content"><span>square-enix-fan-site app is running!</span></div>
  <app-games></app-games>
</section>
